import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Button from "../../../../../../ui/Button";
import DataSelect from "../../../../../../ui/DataSelect";

const DialogTitle = withStyles(theme => ({
  root: {
    width: 450,
    color: "#778899",
    "& > h2": {
      fontSize: 12
    }
  }
}))(MuiDialogTitle);

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    display: "flex"
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: "16px",
    "& > button:first-of-type": {
      marginRight: 4
    }
  }
}))(MuiDialogActions);

const AddAuthorModal = ({
  showDialog,
  title,
  closeDialog,
  organizationList,
  change,
  state,
  editOrganization
}) => {
  return (
    <Dialog open={showDialog}>
      <div>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Grid container justify="space-between">
            <DataSelect
              dataSource={organizationList || []}
              getOptionLabel={option => (option ? option.shortName : option)}
              value={state.organization && state.organization.id}
              onChange={value => change("organization", value)}
              disableClearable
              label="Мои организации"
            />
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={closeDialog}>Отмена</Button>
          <Button onClick={editOrganization} color="green">
            Добавить
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default AddAuthorModal;
